<div class="picker">
  <input
    type="color"
    #colorPicker
    (input)="colorChange($event)"
    (change)="colorPicked($event)"
    [value]="current"
    class="picker__input" />
  <div class="picker__display" [ngStyle]="style$ | async" (click)="colorPicker.click()"></div>
</div>
